module.exports = __webpack_public_path__ + "img/bg.8908ebbf.jpg";